var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            width: "600px",
            "append-to-body": "",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.method != "add"
            ? _c(
                "el-button",
                {
                  staticClass: "mb8",
                  attrs: {
                    size: "medium",
                    icon: "el-icon-edit",
                    type: "warning",
                    disabled: !_vm.hasPermission(
                      "unmspace:cecUnmSpanceContent:edit"
                    ),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handEditorView(_vm.method)
                    },
                  },
                },
                [_vm._v("编辑")]
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主图", prop: "" } },
                        [
                          _c("CropperView", {
                            ref: "listImageRef",
                            attrs: {
                              imgSrc: _vm.inputForm.pic,
                              disabled: _vm.method === "view",
                              actionButtonFlag: true,
                              autoCropWidth: 80,
                              autoCropHeight: 80,
                              objectFit: "cover",
                              listIndex: 1,
                            },
                            on: {
                              updateChange: function ($event) {
                                return _vm.changeImage($event, _vm.inputForm)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "排序",
                            prop: "sort",
                            rules: [
                              {
                                required: true,
                                message: "排序不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写排序" },
                            model: {
                              value: _vm.inputForm.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "sort", _vm._n($$v))
                              },
                              expression: "inputForm.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "中文名称",
                            prop: "nameCn",
                            rules: [
                              {
                                required: true,
                                message: "中文名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写中文名称",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.nameCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameCn", $$v)
                              },
                              expression: "inputForm.nameCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英文名称",
                            prop: "nameEn",
                            rules: [
                              {
                                required: true,
                                message: "英文名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写英文名称",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.nameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameEn", $$v)
                              },
                              expression: "inputForm.nameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "描述（中）", prop: "", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写", maxlength: "255" },
                            model: {
                              value: _vm.inputForm.descriptionCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "descriptionCn", $$v)
                              },
                              expression: "inputForm.descriptionCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "描述（英）", prop: "", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写", maxlength: "255" },
                            model: {
                              value: _vm.inputForm.descriptionEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "descriptionEn", $$v)
                              },
                              expression: "inputForm.descriptionEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }